import { render, staticRenderFns } from "./TextHeading3.vue?vue&type=template&id=282db7f0&scoped=true"
import script from "./TextHeading3.vue?vue&type=script&lang=js"
export * from "./TextHeading3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282db7f0",
  null
  
)

export default component.exports